import { useState } from 'react';
import { _TypedDataEncoder } from 'ethers/lib/utils';
import { useSwap } from '@/contexts/SwapProvider';
import ConfirmSwapContent from '../mobile/ConfirmSwapContent';
import FeeInfoModal from '../mobile/FeeInfoModal';
export default function PreSwapConfirmationModal({
  onClickBack
}) {
  const {
    setIsConfirmationDialogOpen
  } = useSwap();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [infoType, setInfoType] = useState('genius');
  function toggleModal() {
    setIsModalOpen(!isModalOpen);
    setIsConfirmationDialogOpen(true);
  }
  return <>
      <ConfirmSwapContent setInfoType={setInfoType} setIsModalOpen={setIsModalOpen} onClickBack={onClickBack} data-sentry-element="ConfirmSwapContent" data-sentry-source-file="PreSwapConfirmationModal.tsx" />
      <FeeInfoModal infoType={infoType} isModalOpen={isModalOpen} toggleModal={toggleModal} data-sentry-element="FeeInfoModal" data-sentry-source-file="PreSwapConfirmationModal.tsx" />
    </>;
}